"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("./styles");
var Spinner = function (_a) {
    var variant = _a.variant;
    var theme = (0, styled_components_1.useTheme)();
    var stroke = variant === 'primary' ? theme.colors.stroke.white : theme.button.stateColors.disabled;
    return ((0, jsx_runtime_1.jsx)("output", { children: (0, jsx_runtime_1.jsx)(styles_1.Svg, __assign({ viewBox: "22 22 44 44", width: "22", height: "22" }, { children: (0, jsx_runtime_1.jsx)(styles_1.Circle, { cx: "44", cy: "44", r: "20.2", fill: "none", stroke: stroke, strokeWidth: "3.6" }) })) }));
};
exports.default = Spinner;
